import { queryApi } from "src/utils/api/ApiMethods"
import { arrayToUrlQueryString } from "src/utils/api/query_param_helpers"

export const queryUserInvoices = ({
  dueDateLteq,
  dueDateGteq,
  statuses,
  marinas,
  types,
}) => {
  const params = new URLSearchParams({})

  if (dueDateLteq) params.append("due_date_lteq", dueDateLteq)
  if (dueDateGteq) params.append("due_date_gteq", dueDateGteq)

  const statusQueryString = arrayToUrlQueryString({
    queryParam: "statuses",
    values: statuses,
  })
  const marinaQueryString = arrayToUrlQueryString({
    queryParam: "marinas",
    values: marinas,
  })
  const typeQueryString = arrayToUrlQueryString({
    queryParam: "types",
    values: types,
  })
  const baseUrl = `/account/invoices`
  const queryParams = `${params.toString()}${statusQueryString}${marinaQueryString}${typeQueryString}`

  return queryApi(`${baseUrl}?${queryParams}`)
}

export const queryUnsettledInvoiceTotalsByCurrency = () => {
  return queryApi("/account/invoices_and_payments/unsettled_totals")
}
